import { render } from "./Barrierefreiheit.vue?vue&type=template&id=3946e13f&scoped=true"
import script from "./Barrierefreiheit.vue?vue&type=script&lang=js"
export * from "./Barrierefreiheit.vue?vue&type=script&lang=js"

import "./Barrierefreiheit.vue?vue&type=style&index=0&id=3946e13f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3946e13f"]])

export default __exports__